import { basicEnum } from "./base";

export const StepStatusEnum = basicEnum([
    {
        label: "EMPTY",
        value: "E",
    },
    {
        label: "INITIALIZED",
        value: "I",
    },
    {
        label: "PROGRESSING",
        value: "P",
    },
    {
        label: "DONE",
        value: "D",
    },
]);

export namespace StepStatusEnum {
    export type Labels = (typeof StepStatusEnum)["labels"][number];
    export type Values = (typeof StepStatusEnum)["values"][number];
}
